import { render, staticRenderFns } from "./CustomerMalha.vue?vue&type=template&id=1f2913c3&scoped=true"
import script from "./CustomerMalha.vue?vue&type=script&lang=js"
export * from "./CustomerMalha.vue?vue&type=script&lang=js"
import style0 from "./CustomerMalha.vue?vue&type=style&index=0&id=1f2913c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2913c3",
  null
  
)

export default component.exports